import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../styles/navbar.css';

const AppNavbar = () => {

  const isAuthenticated = localStorage.getItem('auth') === 'true';
  const mariaConfig = localStorage.getItem('mariadb_config');
  const nameSala = localStorage.getItem('namesala');
  const user = JSON.parse(localStorage.getItem('user'));
  const userRole = user?.role;

  const location = useLocation();
  const hideNavbar = location.pathname === '/login' || !isAuthenticated;
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post('/logout', {}, { withCredentials: true });
    } catch (err) {
      console.error('Error al cerrar sesión', err);
    } finally {
      localStorage.clear();
      navigate('/login');
    }
  };

  const handleVolver = () => {
    localStorage.removeItem('mariadb_config');
    localStorage.removeItem('numservicios');
    localStorage.removeItem('numventanillas');
    localStorage.removeItem('namesala');
    localStorage.removeItem('id_sala');
    localStorage.removeItem('url_principal');
    localStorage.removeItem('url_secundario');
    navigate('/salas'); // vuelve a la vista de salas
  };

  if (hideNavbar) return null;

  return (
    <Navbar expand="lg" className="custom-navbar" style={{ backgroundColor: '#3b629d' }} variant="dark">
      <Container fluid>
        {/* Logo */}
        <Navbar.Brand as={NavLink} className="logo-container d-flex align-items-center justify-content-center">
            <img
                src={"/assets/LogotipoSITEturnos.png"}
                alt="Logo"
                className="logo-image"
            />
        </Navbar.Brand>

        {/* Nombre de la sala */}
        {mariaConfig && nameSala && (
          <div style={{marginTop: '10px'}} className="w-40 text-white d-flex flex-column text-start align-items-start px-3">
            <span style={{ fontSize: '12px', lineHeight: '1' }}>SALA:</span>
            <span style={{ fontSize: '20px', fontWeight: 'bold', lineHeight: '1.2' }}>{nameSala.toUpperCase()}</span>
          </div>
        )}
     
        {/* Botón hamburguesa */}
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        {/* Menú */}
          <Navbar.Collapse id="main-navbar-nav">
            <Nav className="ms-auto" >
              {/* Si ya hay base seleccionada (MariaDB activa) */}
              {mariaConfig ? (
                <>
                  <Nav.Link as={NavLink} to="/home" className="text-white ms-3">Inicio</Nav.Link>
                  <Nav.Link as={NavLink} to="/servicios" className="text-white ms-3">Servicios</Nav.Link>
                  <Nav.Link as={NavLink} to="/ventanillas" className="text-white ms-3">Ventanillas</Nav.Link>
                  <Nav.Link as={NavLink} to="/pantallas" className="text-white ms-3">Pantallas</Nav.Link>
                  <Nav.Link onClick={handleVolver} className="text-white ms-3">Volver a Salas</Nav.Link>
                </>
              ) : (
                <>
                  {userRole === 'admin' && (
                    <>
                      <Nav.Link as={NavLink} to="/empresas" className="text-white ms-3">Empresas</Nav.Link>
                      <Nav.Link as={NavLink} to="/salas" className="text-white ms-3">Salas</Nav.Link>
                      <Nav.Link as={NavLink} to="/users" className="text-white ms-3">Usuarios</Nav.Link>
                    </>
                  )}
                  {userRole === 'coordinador' && (
                    <>
                      <Nav.Link as={NavLink} to="/salas" className="text-white ms-3">Salas</Nav.Link>
                      <Nav.Link as={NavLink} to="/users" className="text-white ms-3">Usuarios</Nav.Link>
                    </>
                  )}
                </>
              )}
              <Nav.Link as={NavLink} to="/cerrar" onClick={handleLogout} className="text-white ms-3">Cerrar Sesión</Nav.Link>
            </Nav>
          </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;

